import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { getBackgroundColor } from "./utils";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { ITotalScoreColors } from "../demand-size/types";
import { ITotalScoreBgType } from "../demand-size/types";
import { GrayPalette } from "./palette";

const WidgetWrapper = styled(FlexRow)`
    width: calc(50% - 16px);
    flex-wrap: wrap;
    padding: 50px 0;
    margin: 8px;
    border-radius: 4px;
`;

export const ChangeWrapper = styled(WidgetWrapper)<{ color: ITotalScoreColors }>`
    align-items: normal;
    align-content: center;
    justify-content: center;
    background-color: ${({ color }) => getBackgroundColor(color, ITotalScoreBgType.BACKGROUND)};
`;

const labelWrapper = styled(CenteredFlexRow)`
    width: 100%;
`;
export const DataText = styled.span<{ color: ITotalScoreColors }>`
    background-color: ${({ color }) => getBackgroundColor(color, ITotalScoreBgType.LABEL)};
    width: 128px;
    align-self: center;
    border-radius: 4px;
    text-align: center;
`;
export const VolumeChangeLabel = styled(labelWrapper)`
    height: 20px;
    ${DataText} {
        ${setFontVariant("dataTable2", colorsPalettes.carbon[0])};
        height: 18px;
        line-height: 18px;
    }
`;
export const VolumeChangeNumber = styled(labelWrapper)`
    margin-bottom: 1px;
    ${DataText} {
        ${setFontVariant("h4", colorsPalettes.carbon[0])};
        height: 40px;
        line-height: 40px;
    }
`;
export const VolumeChangeDates = styled(CenteredFlexRow)`
    width: 100%;
    margin-top: 12px;
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[500])};
`;

const NoDataContainer = styled(WidgetWrapper)`
    justify-content: center;
    padding: 75px 0;
    height: 106px;
`;
export const NoDataContainerBackground = styled(NoDataContainer)`
    background-color: ${GrayPalette[ITotalScoreBgType.BACKGROUND]};
`;
const LoaderContainer = styled(WidgetWrapper)`
    padding: 70px 0;
    height: 120px;
`;
export const LoaderContainerBackground = styled(LoaderContainer)`
    background-color: ${GrayPalette[ITotalScoreBgType.BACKGROUND]};
`;
